<template>
    <div class="convention" v-if="convention && user">
        <breadcrumb
            v-if="!displayPrintFormat"
            :section="{ title: 'Conventions Collectives', to: '/espace-client/conventions-collectives' }"
        />

        <convention-header
            :user="user"
            :convention="convention"
            :displayPrintFormat="displayPrintFormat"
        />

        <sep name="S" />

        <convention-menu v-if="!displayPrintFormat" :convention="convention" :user="user" />

        <sep name="L" />

        <router-view :convention="convention" :user="user"></router-view>

        <scroll-top />
    </div>
</template>

<script>
import ScrollTop from "src/components/common/scrollTop/ScrollTop.vue";
import conventionManager from "./managers/conventionManager";
import ConventionHeader from "./ConventionHeader.vue";
import ConventionMenu from "./ConventionMenu.vue";
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";

export default {
    components: { ConventionHeader, ConventionMenu, ScrollTop },
    props: ["user"],
    data() {
        return {
            convention: null,
        };
    },
    async mounted() {
        const { conventionId, variantNumber } = this.$route.params;
        this.updateConvention(conventionId, variantNumber);
        EventBus.$on("convention:force-update", () => {
            const { conventionId, variantNumber } = this.$route.params;
            this.updateConvention(conventionId, variantNumber, true);
        });
    },
    watch: {
        $route(to) {
            const { conventionId, variantNumber } = to.params;
            this.updateConvention(conventionId, variantNumber);
        },
    },
    methods: {
        async updateConvention(conventionId, variantNumber, forceUpdate = false) {
            const convention = await Services.api.convention.getByConventionId(
                conventionId,
                variantNumber,
                forceUpdate
            );
            this.convention = conventionManager.generateTitleIdsForConvention(convention);
        },
    },
    computed: {
        displayPrintFormat() {
            return this.$route.name === "convention-section-print";
        },
    },
};
</script>
